export default "__VITE_ASSET__CHFmgJH8__"